/*global google*/
/*global window*/
import React from 'react';
import { useHistory } from 'react-router-dom';
import { withScriptjs, withGoogleMap, GoogleMap, GroundOverlay, Marker } from 'react-google-maps';
import NumberFormat from 'react-number-format';
import { Button, Form, FormTextInput, Grid, Icon } from 'tabler-react';
import * as qs from 'qs';
import { ScrollElement, scroller } from 'react-scroll';
import Modal from 'react-modal';
import InputMask from 'react-input-mask';

Modal.setAppElement('#root')

const Map = withScriptjs(withGoogleMap(props =>
  <GoogleMap
    ref={props.mapRef}
    mapTypeId={google.maps.MapTypeId.SATELLITE}
    options={{
      fullscreenControl: false,
      mapTypeControl: false,
      scrollwheel: true,
      signInControl: false,
      streetViewControl: false,
    }}
    defaultZoom={props.mapZoom}
    defaultCenter={{ lat: parseFloat(props.data?.project?.nativeMapLatitude || 0), lng: parseFloat(props.data?.project?.nativeMapLongitute || 0)}}
  >
    {
      props.data &&
      <GroundOverlay
        defaultUrl={props.data?.project.nativeMapOverlayImageUrl}
        defaultBounds={new google.maps.LatLngBounds(
          new google.maps.LatLng(parseFloat(props.data?.project.nativeMapOverlayImageLeftLatitude), parseFloat(props.data?.project.nativeMapOverlayImageLeftLongitude)),
          new google.maps.LatLng(parseFloat(props.data?.project.nativeMapOverlayImageRightLatitude), parseFloat(props.data?.project.nativeMapOverlayImageRightLongitude))
        )}
      />
    }
    {
      props.data && props.data?.lots?.map(lot => (
        <Marker
          key={lot.id}
          position={{ lat: lot.data?.coordinate.latitude, lng: lot.data?.coordinate.longitude }}
          motionTracking={false}
          icon={
            lot.id === props.selectedLot?.id ? null : 'https://www.guerini.com.br/mapadevendas/images/SEMSTATUS.png'
          }
          onClick={() => props.onLotClick(lot)}
        />
      ))
    }
    {
      props.data && props.data?.linkedLots?.map(lot => (
        <Marker
          key={lot.id}
          position={{ lat: lot.data?.coordinate.latitude, lng: lot.data?.coordinate.longitude }}
          motionTracking={false}
          icon={
            lot.id === props.selectedLot?.id ? null : 'https://www.guerini.com.br/mapadevendas/images/SEMSTATUS_PASTEL.png'
          }
          onClick={() => props.onLotClick(lot)}
        />
      ))
    }
  </GoogleMap>
));

const LotCard = ScrollElement(({mode, name, id, item, project, selectedLot, setSelectedLot, isLinkedLot, onPreReservationClick, onCloseClick}) => (
  <div
    name={name}
    id={id}
    className="card mb-2"
    style={
      selectedLot?.id === item.id ?
      {
        boxShadow: '0px 12px 4px -4px rgba(32,32,32,0.5)',
        zIndex: 2,
        borderWidth: 1,
        borderStyle: isLinkedLot ? 'dashed' : 'solid ',
        borderColor: 'rgba(32,32,32,0.5)'
      }
      :
      {
        cursor: 'pointer'
      }
    }
    onClick={() => {
      if (selectedLot?.id !== item.id) {
        setSelectedLot(item)
      }
    }}
  >
    <div
      className="d-flex justify-content-between m-3"
      style={{borderBottom: '1px solid #DDD'}}
    >
      <div>
        <div className="primary-color" style={{fontSize: '18px', fontWeight: 800}}>{item.identifier}</div>
        <small className="d-block text-muted">
        { item.kind ?  item.kind : (
          project?.kind === 'residential' ? 'Residencial' : (
            project?.kind === 'business' ? 'Empresarial' : (
              project?.kind === 'area' ? 'Área': (
                project?.kind === 'mixed' ? 'Misto': ''
              )
            )
          )
        )}
        {
           project?.name ? ` - ${project?.name}` : ''
        }
        </small>
      </div>
      <div>
        { 
          mode === 'mobile' &&
          <Button link className="m-0 p-0 pt-1" onClick={() => onCloseClick(item)}>
            <Icon name="x-circle"/>
          </Button>
        }
      </div>
    </div>
    <div className="px-3 pb-3" style={{fontSize: '14px'}}>
      <div className="d-flex justify-content-between py-1">
        <span>Área Real (m²)</span>
        <NumberFormat
          value={item.area/100}
          thousandSeparator="."
          decimalSeparator=","
          decimalScale={2}
          displayType="text"
          fixedDecimalScale={true}
          renderText={value => <span style={{textAlign: 'right'}}>{value}</span>}/>
      </div>

      {
        (item.data?.measurementLink != null && item.data?.measurementLink.length > 0) &&
        <div className="d-flex justify-content-between py-1">
          <span>Medidas, Foto e Observações</span>
          <span style={{textAlign: 'right'}}><a target="_blank" href={item.data?.measurementLink}>Link</a></span>
        </div>
      }
    </div>
    {
      (selectedLot?.id === item.id && onPreReservationClick) && !isLinkedLot &&
      <div className="mx-3 mb-1" style={{borderTop: '1px solid #DDD'}}>
        <div className="text-right">
          <Button link className="px-0" onClick={() => onPreReservationClick(item)}>SAIBA MAIS</Button>
        </div>
      </div>
    }
    {
      (selectedLot.id === item.id && isLinkedLot) &&
      <div className="d-flex mx-3 mb-1" style={{borderTop: '1px solid #DDD'}}>
        <div className="text-center py-2" style={{fontWeight: 600}}>
          Este lote pertence a outro projeto, procure o corretor para saber mais sobre.
        </div>
      </div>
    }
  </div>
));

function ProtocolMapProjectPage() {
  const history = useHistory();

  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [id, setId] = React.useState(null);
  const [mapZoom, setMapZoom] = React.useState(17);
  const [data, setData] = React.useState(null);
  const [selectedLot, setSelectedLot] = React.useState({});
  const [mode, setMode] = React.useState('desktop')

  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [cellphone, setCellphone] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [contactForm, setContactForm] = React.useState('Me ligue pela manhã');
  const [errors, setErrors] = React.useState({});
  const [valid, setValid] = React.useState(false);

  const mapRef= React.useRef(null);

  React.useEffect(() => {
    if (history.location.search && history.location.search.length > 0) {
      const params = qs.parse(history.location.search.replace('?', ''));
      if (params.id && params.id.length > 0) {
        setId(params.id);
      }

      if (params.mapZoom && !isNaN(parseInt(params.mapZoom))) {
        setMapZoom(parseInt(params.mapZoom));
      }

      if (params.mode && params.mode.length > 0) {
        setMode(params.mode);
      }
    }
  }, []);

  React.useEffect(() => {
    (async () => {
      if (id) {
        const res = await fetch(`/api/portal/maps/${id}`);
        const json = await res.json();
        json.linkedProjects = json?.linkedProjects?.reduce((acc, project) => ({...acc, [project.id]: project}), {});

        setData(json);
      }
    })();
  }, [id]);

  React.useEffect(() => {
    if (selectedLot?.id && data && mapRef.current) {
      scroller.scrollTo(`${selectedLot.id}`, {
        containerId: 'lots',
        smooth: true,
      })

      mapRef.current.panTo(new google.maps.LatLng(selectedLot?.data?.coordinate.latitude, selectedLot?.data?.coordinate.longitude))
    }
  }, [selectedLot]);

  React.useEffect(() => {
    const newErrors = {};

    if (!name) newErrors.name = "Campo obrigatório";
    else if (name.match(/\w+ \w+/i) === null) newErrors.name = "Nome e sobrenome são obrigatórios";
    
    if (!email) newErrors.email = "Campo obrigatório";
    else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/))
      newErrors.email = "Email inválido";

    if (!cellphone) newErrors.cellphone = "Campo obrigatório";

    setErrors(newErrors);
    setValid(Object.keys(newErrors).length === 0)
  }, [name, email, cellphone]);

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!valid) {
      return alert('O formulário está com erros, corrija os antes de continuar');
    }

    try {
      const res = await fetch(`/api/portal/maps/${id}`, {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          lot: {
            id: selectedLot.id,
            identifier: selectedLot.identifier,
            kind: selectedLot.kind,
            area: ((selectedLot.area || 0 )/100).toFixed(2).replace('.', ','),
          },
          name,
          email,
          contactForm,
          cellphone,
          message,
        })
      });

      alert('Sua solicitação foi enviada com sucesso');

      setModalIsOpen(false);
    } catch (err) {
      alert('Algo deu errado, tente novamente mais tarde');
    }
  }

  return (
    data ?
      <div style={{height: '100%', width: '100%'}}>
        <div style={{
          bottom: 0,
          right: 0,
          position: 'absolute',
          top: 0,
          left: mode === 'desktop' ? 384 : 0,
        }}>
          <Map
            mapRef={mapRef}
            data={data}
            selectedLot={selectedLot}
            onLotClick={setSelectedLot}
            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyB4kgwYSTYdTsT6efHQLYOPZUuB-S5zTNI&v=3.42&libraries=geometry,drawing,places"
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `100%` }} />}
            mapElement={<div style={{ height: `100%` }} />}
            mapZoom={mapZoom}
          />
        </div>
        {
          mode === 'desktop' ?
          <div
            style={{
              backgroundColor: '#EEF0F2',
              bottom: 0,
              left: 0,
              position: 'absolute',
              top: 0,
              width: 384,
              zIndex: 10
            }}
          >
            <div
              id="lots"
              style={{
                backgroundColor: '#EEF0F2',
                bottom: 0,
                left: 0,
                overflowY: 'scroll',
                paddingTop: 8,
                position: 'absolute',
                right: 0,
                top: (data?.project?.showSimulationPriceWarning ? 36 : 0),
              }}
            >
            {
              data?.lots?.map((lot) => 
                <LotCard
                mode={mode}
                  key={`${data?.project?.id}_${lot.id}`}
                  name={`${lot.id}`}
                  item={lot}
                  project={data?.project}
                  isLinkedLot={false}
                  selectedLot={selectedLot}
                  setSelectedLot={setSelectedLot}
                  onPreReservationClick={item => {
                    setModalIsOpen(true);
                  }}
                />
              )
            }
            {
              data?.linkedLots?.map((lot) => 
                <LotCard
                mode={mode}
                  key={`${lot.projectId}_${lot.id}`}
                  name={`${lot.id}`}
                  item={lot}
                  project={data?.linkedProjects[lot.projectId]}
                  isLinkedLot={true}
                  selectedLot={selectedLot}
                  setSelectedLot={setSelectedLot}
                  onPreReservationClick={null}
                />
              )
            }
            </div>
          </div>
          :
          selectedLot?.id &&
            <div
              style={{
                top: 0,
                left: 0,
                right: 0,
                position: 'absolute',
                zIndex: 10
              }}
            >
              <LotCard
                mode={mode}
                item={selectedLot}
                project={data?.linkedProjects[selectedLot?.projectId] || data?.protocol?.project || {}}
                isLinkedLot={data?.linkedProjects?.[selectedLot?.projectId] !== undefined}
                selectedLot={selectedLot}
                setSelectedLot={setSelectedLot}
                onPreReservationClick={item => {
                  setModalIsOpen(true);
                }}
                onCloseClick={item => {
                  setSelectedLot({})
                }}
              />
            </div>
        }

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => {
            setModalIsOpen(false)
          }}
          style={{
            content : mode === "desktop" ? {
              top                   : '50%',
              left                  : '50%',
              right                 : 'auto',
              bottom                : 'auto',
              marginRight           : '-50%',
              minWidth:  600,
              transform             : 'translate(-50%, -50%)',
              zIndex: 100,
            } : {
              top                   : 0,
              left                  : 0,
              right                 : 0,
              bottom                : 0,
              zIndex: 100,
              overflow: "scroll"
            }, 
            overlay: {
              zIndex: 100
            }
          }}
          contentLabel="SAIBA MAIS"
        >
          <div style={{textAlign: 'right', color: '#00265C'}}>  
              <Icon className="ml-1" onClick={() => setModalIsOpen(false)} name="x-circle"/>
          </div>

          <h4>Quer saber mais sobre o {data?.project.name} [{selectedLot?.identifier}]?</h4>
          <p>Preencha o formulário abaixo que entraremos em contato para contar mais</p>
          
          <Form onSubmit={onSubmit}>
            <FormTextInput
              name="name"
              label="Qual o seu nome completo?"
              onChange={(e) => {setName(e.target.value)}}
              value={name}
              error={errors && errors?.name}
            />
            <FormTextInput
              name="email"
              label="Qual o seu email para contato?"
              onChange={(e) => {setEmail(e.target.value)}}
              value={email}
              error={errors && errors?.email}
            />
            <InputMask mask="(99) 99999-9999" value={cellphone} onChange={(e) => {setCellphone(e.target.value)}}>
              {(inputProps) => 
                <FormTextInput
                  {...inputProps}
                  name="cellphone"
                  label="Qual o seu celular para contato?"
                  error={errors && errors?.cellphone}
                />
              }
            </InputMask>
            <Form.Group label="Como prefere que entremos em contato?">
              <Form.Select name="contactForm" defaultValue={'Me ligue pela manhã'} onChange={(e) => {setContactForm(e.target.value)}}>
                <option value="Me ligue pela manhã">
                  Me ligue pela manhã
                </option>
                <option value="Me ligue pela tarde">
                  Me ligue pela tarde
                </option>
                <option value="Envie as informações por email">
                  Envie as informações por email
                </option>
              </Form.Select>
            </Form.Group>
            <FormTextInput
              name="message"
              label="Quer deixar alguma mensagem?"
              onChange={(e) => {setMessage(e.target.value)}}
              value={message}
              error={errors && errors?.message}
            />
            <Button type="submit" block outline color="primary" disabled={!valid}>
              Enviar
            </Button>
          </Form>
        </Modal>
      </div>
    :
    <div className="page" style={{backgroundImage: "url('./assets/images/landing_background.jpg')", backgroundSize: 'cover'}}/>
  )
}

export default ProtocolMapProjectPage;